import { MockAuthService } from './MockAuthService.js';
import { FirebaseAuthService } from './FirebaseAuthService.js';

export function createAuthService() {
  return (import.meta.env.VITE_AUTH_MODE === 'firebase') ? new FirebaseAuthService() : new MockAuthService();
}
